import { z } from 'zod';

export const RubricBankItemCriteria = z.object({
  id: z.string(),
  description: z.string(),
  weight: z.number(),
});

export type RubricBankItemCriteria = z.infer<typeof RubricBankItemCriteria>;
